import React from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import { COLORS, SIZES, WEIGHT } from "theme";
import FeatureSection from "Pages/Telematics/FeatureSection";
import Dots from "assets/dots.svg";
import Hexagon1 from "assets/hexagon_1.svg";
import { HOST } from "api/apiClient";
import H2 from "ReusableComponents/Text/H2";

const AppInfoReverse = ({ list, title, subtitle, img, small, alt }) => {
  console.log(
    "🚀 ~ file: AppInfoReverse.js:12 ~ AppInfoReverse ~ itle, subtitle,",
    title,
    subtitle
  );
  return (
    <>
      <Box
        background={COLORS.lightBlack}
        display="flex"
        justifyContent="center"
        alignItems="center"
        paddingTop="90px"
        paddingBottom="60px"
        position="relative"
        flexDirection={small ? "column" : "row"}
      >
        <Box display="flex" w="900px" justifyContent="space-between">
          <Box>
            <img
              src={HOST + img}
              alt={alt}
              height={"633px"}
              style={{ maxWidth: "fit-content" }}
            />
          </Box>
          <Box display="flex" flexDirection="column" marginLeft="100px">
            <Box display="flex" flexDirection="column" margin="16px 0">
              <H2
                fontSize={SIZES.twenty}
                fontWeight={WEIGHT.bold}
                textColor={COLORS.lightGrey}
                marginBottom={SIZES.eighteen}
              >
                {title}
              </H2>
              <Text
                fontSize={SIZES.forty}
                fontWeight={WEIGHT.bold}
                textColor={COLORS.white}
                margin={SIZES.zero}
              >
                {subtitle}
              </Text>
            </Box>

            <FeatureSection list={list} />
          </Box>
          <img
            src={Dots}
            alt="dots"
            style={{ position: "absolute", top: 112, right: 0 }}
          />
          <img
            src={Hexagon1}
            alt="hexagon"
            style={{ position: "absolute", bottom: 80, right: 50 }}
          />
        </Box>
      </Box>
    </>
  );
};

export default AppInfoReverse;
